export default __webpack_public_path__ + "static/media/news-1.37166513.png";